<template>
  <div class="page" id="page-insurance-detail-price">


    <div class="header">
    <div class="container">
      <div class="section-insure">
        <div class="banners">
          <div class="banner schema2">비교견적</div>
          <div class="banner schema">{{ estimate.estimate_type }}보험</div>
        </div>

        <div class="title">
          {{ infoBody.title }}
        </div>

        <div v-if="type === 'contract' && infoBody.title !== ''" class="img">
          <img :src="$store.state.allianceImgList.find(o=> infoBody.title.indexOf(o.name) >= 0).value" />
        </div>

        <div class="subtitle">
          {{ estimate.customer_name }}님께서 {{ estimate.updatedAt }}에 신청하신 자동차 보험의 {{infoBody.title}} 상세 견적서는 다음과 같습니다.
        </div>
      </div>

      <template v-if="type === 'contract'">
      <div class="section-information">
        <ul>
          <li v-if="false">
            <p class="title">구분</p>
            <p class="description">{{ infoBody.division }}</p>
          </li>

          <li>
            <p class="title">차명</p>
            <p class="description">{{ infoBody.autoName }}</p>
          </li>

          <li>
            <p class="title">가입기간</p>
            <p class="description">{{ infoBody.durationStart + ' ~ ' + infoBody.durationEnd }}</p>
          </li>

          <li>
            <p class="title">보험료</p>
            <p class="description">{{ infoBody.amount + '원' | number }}</p>
          </li>
        </ul>
      </div>

      <ul class="buttons">

        <router-link tag="li" class="button schema"
        :to="{ name: 'EstimateConsultation', query: { ectype: estimate.estimate_type + '보험', admin: 35, customer: $store.state.customer.profile._id, adminj:data[1].value[0].adminid, source:'홈피마이보험', memo: infoBody.title + ' 가입상담 신청' } }" >해당보험 가입상담</router-link>
        <li class="button" @click="openKakao(data[1].value[0].kakaotalk)" >담당사원 카카오톡</li>
      </ul>
      </template>


    </div>
    </div>

    <div class="footer">
      <div class="container">
        <masonry :cols="{default: 2, 700: 1}" :gutter="20">
          <div class="section-information clear">
            <div class="title">
              {{ data[0].title }}
            </div>
            <ul>
              <template v-for="(item, index) in data[0].value">
                <template v-if="item.label !== '할인특약'">
                  <li :key="index">
                    <p class="label w3">{{ item.label }}</p>
                    <p class="value w3">{{ item.value }}</p>
                    <p class="price w3">{{ item.price + ' 원' | number }}</p>
                  </li>
                </template>
                
                <template v-else>
                  <template v-if="item.item.length === 1 && (item.item[0].price === '0' || item.item[0].price === 0)">
                    <li>
                      <p class="label w3">특약</p>
                      <p class="value w3" v-html="item.item[0].label" style="white-space: nowrap"></p>
                      <p class="price w3" style="color: #bf1f1f"></p>
                    </li>
                  </template>

                  <template v-for="(item2, index2) in item.item" v-else>
                    <li v-if="index2 === 0">
                      <p class="label w3">{{ item.label }}</p>
                      <p class="value w3" v-html="item2.label" style="white-space: nowrap"></p>
                      <p class="price w3" style="color: #bf1f1f">-{{ item2.price + ' 원' | number }}</p>
                    </li>

                    <li v-else>
                      <p class="label w3"></p>
                      <p class="value w3" v-html="item2.label" style="white-space: nowrap"></p>
                      <p class="price w3" style="color: #bf1f1f">-{{ item2.price + ' 원' | number }}</p>
                    </li>
                  </template>
                </template>
              </template>
            </ul>
            <div class="section-total" v-if="isMileage">
              <div>
                <p class="label">결제 보험료</p>
                <!-- <p class="value">{{ ( data[0].total ? data[0].total : infoBody.amount ) + ' 원' | number }}</p> -->
                <p class="value">{{ ( infoBody.amount ) + ' 원' | number }}</p>
              </div>

              <div>
                <p class="label2">만기 후 예상환급금*</p>
                <p class="value2">-{{ totalDisacount | number }}원</p>
              </div>

              <div class="desc">
                <p>*마일리지 할인특약은 가입시 결제했다가 만기시 환급해드리는 '후환급할인'이 적용됩니다.</p>
                <p>산출된 금액은 {{ mileKm.toLocaleString() }}km를 기준으로 한 예상 금액이며, 실제 환급금은 만기시 운행거리 실적에 따라 달라질 수 있습니다.</p>
              </div>
            </div>

            <div class="section-total" v-else>
              <div>
                <p class="label">합계 보험료</p>
                <p class="value">{{ ( infoBody.amount ) + ' 원' | number }}</p>
              </div>              
            </div>

            <div class="section-total" v-if="isMileage">
              <div>
                <p class="label">실제 보험료</p>
                <p class="value3">{{ ( infoBody.amount - totalDisacount ) + ' 원' | number }}</p>
              </div>
            </div>
          </div>

          <div class="section-information manager">
            <div class="title">
              {{ data[1].title }}
            </div>
            <div class="circle profile" :style="{'background-image': `url(${data[1].value[0].imgUrl})`}"
                style='background-repeat: no-repeat;background-position: center;background-size:cover;'>
            </div>
            <div class="item-frame">
              <div class="item">
                {{ data[1].value[0].name }}
              </div>
              <div class="item">
                {{ data[1].value[0].phone }}
              </div>
              <div class="item">
                {{ data[1].value[0].email }}
              </div>

            </div>
            <!--
            <div class="circle phone" @click="callPhone(data[1].value[0].phone.replace(/(-)/g,''))">
              <img :src="'/static/phone.png'" />
            </div>
            <div class="circle kakaotalk" @click="openKakao(data[1].value[0].kakaotalk)" >
              <img :src="'/static/kakao.png'" />
            </div>
            -->
          </div>
        </masonry>

      </div>
    </div>

    <div class="footer" style="background-color: #fff;">
      <div class="container">
        <p style="font-size: 11px;" >※ 이 견적서의 보험료는 보험가입일, 보험개발원 적용율, 보험사별 차량가액 및 인수 기준에 따라 변경될 수 있습니다.</p>
      </div>
    </div>


  </div>
</template>

<script>

import moment from 'moment';

  export default {
    data() {
      return {
        type: "contract",

        compareIndex: 0,

        company: [
          { label: "hd", value: "현대해상" },
          { label: "ss", value: "삼성화재" },
          { label: "db", value: "DB손해보험" },
          { label: "lg", value: "KB손해보험" },
          { label: "ji", value: "MG손해보험" },
          { label: "sd", value: "한화손해보험" },
          { label: "sy", value: "흥국화재" },
          { label: "dh", value: "롯데손해보험" },
          { label: "dy", value: "메리츠화재" }
        ],
        estimateList: [
          { title: "", price: "", compare: "" },
          { title: "", price: "", compare: "" },
          { title: "", price: "", compare: "" },
          { title: "", price: "", compare: "" },
          { title: "", price: "", compare: "" },
        ],
        estimate: [

        ],
        infoBody: {
          title: '',
          division: '',
          autoName: '',
          durationStart: '',
          durationEnd: '',
          amount: '',
        },
        data: [
          {
            title: "보험료",
            value: [
              { label: "", value: "", price: "" },
              { label: "", value: "", price: "" },
              { label: "", value: "", price: "" },
              { label: "", value: "", price: "" },
              { label: "", value: "", price: "" },
              { label: "", value: "", price: "" },
              { label: "", value: "", price: "" },
              { label: "", value: "", price: "" },
              { label: "", value: "", price: "" },
              { label: "", value: "", price: "" },
            ],
            total: ""
          },
          {
            title: "담당사원 정보",
            value: [
              {
                imgUrl: "",
                name: "",
                phone: "",
                email: ""
              }
            ]
          }
        ],
        insurances: [
          { name: "자동차보험", src: "../static/home-insurance-1.png", component: "CarInsurance", value: "자동차보험", label: "자동차보험"},
          { name: "운전자보험", src: "../static/home-insurance-2.png", component: "DriverInsurance", value: "운전자보험", label: "운전자보험"},
          { name: "실손의료보험", src: "../static/home-insurance-3.png", component: "EstimateLosslessMedicalInsurance", value: "실손의료보험", label: "실손의료보험"},
          { name: "암/2대질병 보험", src: "../static/home-insurance-4.png", component: "CancerInsurance", value: "암/2대질병 보험", label: "암/2대질병 보험"},
          { name: "어린이보험", src: "../static/home-insurance-5.png", component: "ChildInsurance", value: "어린이보험", label: "어린이보험"},
          { name: "태아보험", src: "../static/home-insurance-6.png", component: "FetalInsurance", value: "태아보험", label: "태아보험"},
          { name: "정기보험", src: "../static/home-insurance-7.png", component: "TermInsurance", value: "정기보험", label: "정기보험"},
          { name: "종신보험", src: "../static/home-insurance-8.png", component: "WholeLifeInsurance", value: "종신보험", label: "종신보험"},
          { name: "화재보험", src: "../static/home-insurance-9.png", component: "FireInsurance", value: "화재보험", label: "화재보험"},
          { name: "연금보험", src: "../static/home-insurance-10.png", component: "PensionInsurance", value: "연금보험", label: "연금보험"},
          { name: "치아보험", src: "../static/home-insurance-11.png", component: "DentalInsurance", value: "치아보험", label: "치아보험"},
          { name: "치매보험", src: "../static/home-insurance-12.png", component: "DementiaInsurance", value: "치매보험", label: "치매보험"},
          { name: "펫보험", src: "../static/home-insurance-13.png", component: "PetInsurance", value: "펫보험", label: "펫보험" }
        ],
        mileage: 0,
        mileKm: 0,
        totalDisacount: 0,
        isMileage: false,
      }
    },
    created(){
      this.compareIndex = this.$route.query.index;
      this.insureId = this.$route.query.id;
      this.isMileage = this.$route.query.mile && this.$route.query.mile !== 'false' || false;

      this.setData();
    },
    methods: {
      setData(){
        var _this = this;
        this.$store.dispatch( "estimate/getItem", { "_id": _this.insureId } ).then(res => {
          var compareList = res.data.data.conditionCompares[this.$route.query.cdnId];
          var estimate = res.data.data.estiate;
          var estimates = res.data.data.estiates[this.$route.query.cdnId];

          // TODO: 담보 리스트 start, Key 일치 필요 (임시매칭)
          
          // compareList 상세금액
          var extra = JSON.parse(compareList[this.compareIndex].estimate_condition_compare_extra);
          // 담보 옵션
          var tt = JSON.parse(estimates.estimate_condition_extra);

          var extraSort = {
            '대인배상 1': '가입',
            '대인배상 2': '',
            '대물배상': '',
            '자상': '',
            '무보험차': '',
            '차량손해': '',
            '긴급출동': '',
            '할인특약': [],
            '총금액': ''
          }

          for ( let [ key, value ] of Object.entries(extra) ){
            if(key === '긴급출동') extraSort['긴급출동'] = value;
            else if(key === '대물배상')  extraSort['대물배상'] = value;
            else if(key === '대인배상 1')  extraSort['대인배상 1'] = value;
            else if(key === '대인배상 2')  extraSort['대인배상 2'] = value;
            else if(key === '무보험차')  extraSort['무보험차'] = value;
            else if(key === '자상')  extraSort['자상'] = value;
            else if(key === '차량손해')  extraSort['차량손해'] = value;
            else if(key === '총금액')  extraSort['총금액'] = value;
          }

          var insureDetailPrice = [];
          for ( let [ key, value ] of Object.entries(extraSort) ){

            var c = {};

            c.label = key;
            c.price = value;

            if(key === '긴급출동') c.value = tt.condition.담보사항.긴급출동특약
            else if(key === '대물배상') c.value = tt.condition.담보사항.대물배상
            // else if(key === '대인배상 1') c.value = tt.condition.담보사항.대인배상
            else if(key === '대인배상 1') c.value = '가입'
            else if(key === '대인배상 2') c.value = tt.condition.담보사항.대인배상
            else if(key === '무보험차') c.value = tt.condition.담보사항.무보험차상해
            else if(key === '자상') {
              if (tt.condition.담보사항.자기신체사고.indexOf('자') != -1) c.label = '자동차상해'
              else  c.label = '자기신체손해'
              c.value = tt.condition.담보사항.자기신체사고
            }
            else if(key === '차량손해') c.value = tt.condition.담보사항.자기차량손해
            else if (key === '할인특약') {
              let originPrice = tt.insuman[this.$route.query.code] * 1;
              let mileagePrice = tt.insuman[`aftmile_${this.$route.query.code}`] * 1;
            
              c.item = [];
              this.mileKm = tt.insuman.mileKm * 1;

              if (tt.condition.특약정보) {
                Object
                  .keys(tt.condition.특약정보)
                  .filter(key => tt.condition.특약정보[key] === true && key !== '마일리지')
                  .map(key => {
                    c.item.push({ label: key, price: 0 });
                  });
              }
              
              if (extra.마일리지후할인) {
                mileagePrice = extra.마일리지후할인;
                originPrice = extra.총금액;
              }

              if (this.isMileage) {
                this.mileage = originPrice - mileagePrice;
                this.totalDisacount += this.mileage;

                c.item.push({
                  label: '마일리지<span style="font-size: 0.7em">(후환급*)</span>',
                  price: this.mileage
                });
              }
            }

            if( key != '총금액'){
              insureDetailPrice.push(c)
            }
          }

          // 담보 리스트 end




          var tmp = [];
          compareList.forEach(o => {
            var c = {};
            c.title = this.company.filter(cc => cc.label == o.estimate_condition_compare_company)[0].value;
            c.price = o.estimate_condition_compare_amount;
            c.compare = o.estimate_condition_compare_amount - compareList[0].estimate_condition_compare_amount;
            tmp.push(c);
          })

          const companyInfo = this.company.filter(cc => cc.label == compareList[this.compareIndex].estimate_condition_compare_company);

          var infoBody = {
            title: companyInfo[0].value,
            division: 'TODO',
            autoName: estimates.autoName,
            durationStart: moment(estimates.estimate_condition_date_start).format('YYYY.MM.DD'),
            durationEnd: moment(estimates.estimate_condition_date_end).format('YYYY.MM.DD'),
            amount: compareList[this.compareIndex].estimate_condition_compare_amount,
          }

          var estimate_admin_extra = JSON.parse(estimates.admin_extra)
          var admin_kakao = estimate_admin_extra ? (estimate_admin_extra.kakaolink ? estimate_admin_extra.kakaolink : estimate.adminKakaoLink) : estimate.adminKakaoLink

          var admin = {
            adminid: estimates.admin_id,
            imgUrl: estimates.adminProfileUrl,
            name: estimates.admin_name,
            phone: estimates.admin_contact_phone,
            email: estimates.admin_email,
            kakaotalk: admin_kakao
          }

          estimates.updatedAt = moment(estimate.updatedAt).format('YYYY년 MM월 DD일');

          this.estimateList = compareList;
          this.estimate = estimates;
          this.infoBody = infoBody;
          this.data[0].value = insureDetailPrice;
          this.data[0].total = extra.총금액;

          this.data[1].value[0] = admin;

        })
      },
      openKakao(link){
        window.open(link);
      },
      callPhone(link){
        window.open("tel:" + link);
      },
      GetinsurancesName (type) {
        var tmp = this.insurances.find(o =>{
          return o.name.indexOf(type) >= 0
        })
        if(tmp) return tmp.component;
        return ''
      }
    }
  }
</script>
